import { LOADER } from '../app';
import loadPicture from '../loadPicture';
import initSlider from '../libs/initSlider';
import changeActiveSlide from '../changeActiveSlide';
import { tabsSliderOptions, tabsContentSliderOptions } from '../sliders/sliders';

document.addEventListener('DOMContentLoaded', (e) => {
  const PAGE = 'modules';

  const extraFeaturesTabsSlider = initSlider('[data-extra-features-tabs-slider]', tabsSliderOptions);
  const extraFeaturesSlider = initSlider('[data-extra-features-slider]', {
    ...tabsContentSliderOptions,
    thumbs: {
      swiper: extraFeaturesTabsSlider,
      autoScrollOffset: 0.5,
    },
  });

  /*  */

  const modulesTabsSlider = initSlider('[data-modules-tabs-slider]', tabsSliderOptions);
  const modulesSlider = initSlider('[data-modules-slider]', {
    ...tabsContentSliderOptions,
    thumbs: {
      swiper: modulesTabsSlider,
      autoScrollOffset: 0.5,
    },
  });

  modulesTabsSlider.on('click', (swiper) => {
    changeActiveSlide(swiper, PAGE);
  });
  modulesSlider.on('slideChangeTransitionStart', (swiper) => {
    changeActiveSlide(swiper, PAGE);
  });

  /*  */

  const partnershipSections = document.querySelectorAll('[data-partnership-section]');
  // const partnershipCaption = document.querySelector("[data-partnership-caption]");
  const partnershipPicture = document.querySelector('[data-partnership-picture]');

  partnershipSections.forEach((section) => {
    const sectionTitle = section.querySelector('[data-partnership-title]');

    sectionTitle.addEventListener('click', (e) => {
      // const sectionCaption = sectionTitle.textContent;
      const sectionNumber = section.dataset.partnershipSection;

      partnershipSections.forEach((section) => section.classList.remove('active--desktop'));
      section.classList.toggle('active--phone');
      section.classList.add('active--desktop');

      // partnershipCaption.textContent = sectionCaption;
      const loader = partnershipPicture.querySelector('.u_loader_wrap');
      if (!loader) partnershipPicture.innerHTML += LOADER;

      const partnershipSource = partnershipPicture.querySelector('source');
      const partnershipImg = partnershipPicture.querySelector('img');

      setTimeout(() => {
        loadPicture(partnershipImg, partnershipSource, `/img/pages/traders_room/interface/${sectionNumber}`)
          .then((img) => {
            partnershipPicture.querySelector('.u_loader_wrap').remove();
          })
          .catch(() => {
            partnershipPicture.querySelector('.u_loader_wrap').remove();
            console.warn('Image failed to load');
          });
      }, 750);
    });
  });
});
